export default "__VITE_ASSET__f3baf128__"